'use strict';

var GridToolbarRefreshButtonDirective = function GridToolbarRefreshButtonDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-refresh-button.html'),
    controller: 'GridToolbarRefreshButtonController',
    link: function link($scope, element) {
      var notificationTooltip;
      function setLastRefreshedTitle() {
        element.attr('title', $scope.getLastRefreshedNotification());
      }
      if (!$scope.isLiveData) {
        $scope.$watch('lastRefreshed', setLastRefreshedTitle);
      } else {
        notificationTooltip = element.find('.live-data-notification');
        notificationTooltip.popover({
          container: 'body'
        });
        element.hover(function () {
          if (!$scope.isDisabled() && $scope.isNotificationShown()) {
            notificationTooltip.popover('show');
          }
        }, function () {
          notificationTooltip.popover('hide');
        });
      }
      $scope.$watch('liveDataNotification.total', function () {
        if (notificationTooltip) {
          notificationTooltip.popover('hide');
        }
      });
    }
  };
};
GridToolbarRefreshButtonDirective.$inject = [];
module.exports = GridToolbarRefreshButtonDirective;